import {useSelector} from "react-redux";
import {getCurrentAssetId, getFilterPreset} from "../../ducks/assets-duck.js";
import {APP_ROUTES} from "../../App.jsx";

export const useAnnotationLink = () => {
    const filterPreset = useSelector(getFilterPreset)
    const assetId = useSelector(getCurrentAssetId)

    const annotationRoute = APP_ROUTES.annotations.replace(':filterId', filterPreset).replace(':assetId',assetId || '')

    return {
        annotationRoute,
    }

}